import { render } from "./AssistantDock.vue?vue&type=template&id=1db152ff&scoped=true"
import script from "./AssistantDock.vue?vue&type=script&lang=js"
export * from "./AssistantDock.vue?vue&type=script&lang=js"

import "./AssistantDock.vue?vue&type=style&index=0&id=1db152ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db152ff"]])

export default __exports__